import React, {useMemo} from 'react';
import {DataGrid, ruRU} from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import {UserRolesOptions} from "../../utils/roles";


const getUserTableColumns = (contracts) => [
    {field: 'sequenceNumber', headerName: '№', width: 90},
    {field: 'last_name', headerName: 'Фамилия', minWidth: 180},
    {field: 'first_name', headerName: 'Имя', minWidth: 180},
    {field: 'mid_name', headerName: 'Отчество', minWidth: 180},
    {
        field: 'role',
        headerName: 'Роль',
        type: 'singleSelect',
        valueOptions: UserRolesOptions,
        width: 150,
        valueFormatter: (params) => {
            return params.colDef.valueOptions.filter(f => f.value === params.value)[0]?.label || ''
        }
    },

    {
        field: 'contracts', headerName: 'Контракты', flex: 1, minWidth: 220, valueOptions: contracts,
        valueFormatter: (params) => {
            return params.colDef.valueOptions?.filter(f => params.value.includes(f?.id))?.map(el => el.name).join('; ') || ''
        }
    },
    {
        field: 'is_activated',
        headerName: 'Активирован',
        minWidth: 150,
        type: 'boolean',
        sortable: false
    },
]

export const UsersTable = ({users, contracts, companies, onRowClick, loading}) => {
    const columns = useMemo(() => getUserTableColumns(contracts, companies), [contracts, companies])
    return <Paper style={{height: '100%', width: '100%'}}>
        <DataGrid rows={users?.map((el, index) => ({...el, sequenceNumber: index + 1}))}
                  columns={columns}
                  onRowClick={onRowClick}
                  density={'compact'}
                  localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                  disableSelectionOnClick
                  loading={loading}
        />
    </Paper>
}